import React, { useCallback, memo } from 'react';
import { useAdState } from '../contexts/AdContext';

const Advertisement: React.FC = () => {
  const { adMinimized, setAdMinimized } = useAdState();

  // Memoize event handlers to prevent unnecessary re-renders
  const handleMinimize = useCallback(() => {
    setAdMinimized(true);
  }, [setAdMinimized]);

  const handleExpand = useCallback(() => {
    setAdMinimized(false);
  }, [setAdMinimized]);

  // Secure external link opening with proper security attributes
  const handleOpenLink = useCallback(() => {
    const newWindow = window.open('https://www.univeli.com/link/4BP8Zb?url=https%3A%2F%2Fwww.univeli.com%2Fcourse%2Fprepare-me-for-high-tech', '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
      // Secure the window using features in window.open instead of setting .rel
      // Since .rel is not valid on Window object
    }
  }, []);

  return (
    <div 
      className={`copilot-compact-ad ${adMinimized ? 'minimized' : ''}`}
      role="complementary" 
      aria-label="Advertisement"
    >
      <div className="copilot-ad-content">
        {!adMinimized ? (
          <>
            <button 
              className="copilot-ad-minimize"
              onClick={handleMinimize}
              title="הקטן באנר"
              aria-label="הקטן באנר פרסומי"
            >
              −
            </button>
            <h2 className="copilot-ad-title">מחפשים עבודה? </h2>
            <h2> Zero To Hero - Find Your First Job</h2>
<p className="copilot-ad-body">
קורס ממוקד שמכין אותך לשוק העבודה – מקורות חיים ולינקדאין, דרך פרויקט אישי וחיפוש משרות חכם, ועד הכנה מעשית לראיונות ולשאלות ליטקוד. נלמד שיטות, כלים וטיפים שיחסכו זמן ויקרבו אותך למשרה הראשונה!
</p>

            <h3>במחיר של שיעור פרטי!!</h3>
            <button 
              className="copilot-ad-button"
              onClick={handleOpenLink}
              aria-label="לא מצליחים למצוא משרה?"
            >
              לפרטים נוספים
            </button>
          </>
        ) : (
          <>
            <button 
              className="copilot-ad-expand"
              onClick={handleExpand}
              title="הרחב באנר"
              aria-label="הרחב באנר פרסומי"
            >
              +
            </button>
            <span className="copilot-ad-mini-text">לא מצליחים למצוא עבודה?</span>
          </>
        )}
      </div>
    </div>
  );
};

// Prevent unnecessary re-renders using React.memo
export default memo(Advertisement);